import React from 'react';
import { Container } from '@adobe/aem-react-editable-components';
import { uuid } from 'utils/dom';
import cn from 'classnames';
import { propTypes } from './DrawerPropTypes';

const Drawer = (props) => {
  const { title, titleSuffix, titleIcon, titleIconActive, openText, closeText, containerProps = {} } = props;

  const drawer_uuid = uuid();

  const mergedContainerProps = {
    ...containerProps,
    className: cn(containerProps.className, 'calloutContainer', 'cq-Editable-dom', 'cq-Editable-dom--container'),
  };

  return (
    <section className='drawer' {...mergedContainerProps}>
      <input type='checkbox' className='drawer__toggle' id={drawer_uuid} />
      <label className='drawer__header' htmlFor={drawer_uuid}>
        <h3 className='drawer__header__title'>
          {titleIcon && <img className='drawer__header__icon' src={titleIcon} alt={title} />}
          {titleIconActive && (
            <img className='drawer__header__icon drawer__header__icon--active' src={titleIconActive} alt={title} />
          )}
          {title}
          {titleSuffix && <span> ({titleSuffix})</span>}
        </h3>
        <div className='drawer__header__openCta'>{openText}</div>
        <div className='drawer__header__closeCta'>{closeText}</div>
      </label>
      <div className='drawer__content'>
        {/* Placeholder props might be needed depending on Container usage */}
        <Container {...props} />
      </div>
    </section>
  );
};

Drawer.propTypes = propTypes;

export default Drawer;
